import { BehaviorSubject } from "rxjs";
import { PortalAccount } from "../../feature/account/PortalAccount";


export interface UserContext {
    // termsAccepted: BehaviorSubject<boolean>;
    portalAccount: BehaviorSubject<PortalAccount | undefined>;
    countryCode: BehaviorSubject<string | undefined>;
    countryName: BehaviorSubject<string | undefined>;
    region: BehaviorSubject<UserRegion | undefined>;
    localeCode: BehaviorSubject<string>;
    currencyCode: BehaviorSubject<string>;
    contextLoaded: BehaviorSubject<boolean>;
}

export enum UserRegion {
    EU,
    NA
}

export const DEFAULT_REGION = UserRegion.NA;
export const US_COUNTRY_CODE = 'US';
export const US_COUNTRY_ID = 1;